export enum TitleMap {
  currentPassword = 'currentPassword',
  newPassword = 'newPassword',
  confirmPassword = 'confirmPassword',
}

export const titleTranslation = {
  [TitleMap.currentPassword]: 'Auth:currentPassword',
  [TitleMap.newPassword]: 'Auth:newPassword',
  [TitleMap.confirmPassword]: 'Auth:confirmPassword',
};

export const placeholderTranslation = {
  [TitleMap.currentPassword]: 'Auth:currentPasswordDescription',
  [TitleMap.newPassword]: 'Auth:newPasswordDescription',
  [TitleMap.confirmPassword]: 'Auth:confirmPasswordDescription',
};
